module.exports = __webpack_public_path__ + "58d1692d5a128514283f2b3ca6a2a521.png";